module.exports = __webpack_public_path__ + "img/file-upload.af1ccf94.svg";